import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { GetShoppingCartResponse } from 'src/types/cart/shoppingCart';
import axiosInstance from 'src/utils/axios';

async function fetchShoppingCart(): Promise<GetShoppingCartResponse> {
  const res = await axiosInstance.get<GetShoppingCartResponse>(api.getShoppingCart);
  return res.data;
}

const useGetShoppingCartQuery = () =>
  useQuery<GetShoppingCartResponse>({
    queryKey: queryKeys.cart.shoppingCart(),
    queryFn: fetchShoppingCart,
  });

export default useGetShoppingCartQuery;
